import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
// import component 👇
import Drawer from "react-modern-drawer";
import ToggleIcon from "./../../assets/toggle_icon.png";
//import styles 👇
import "react-modern-drawer/dist/index.css";
import Logo from "./../../assets/logo.png"
import "./navbar.css";
import { AiOutlinePoweroff } from "react-icons/ai"
const Navbar = ({ user }) => {
  const { pathname } = useLocation();
  let data = localStorage.getItem("jwt_authorization");
  data = JSON.parse(data);
  const navigate = useNavigate();
  console.log(pathname)
  const Logout = () => {
    localStorage.removeItem("jwt_authorization");
    navigate("/");
    // setIsOpen((prevState) => !prevState)
  };

  let isAdmin = data && data.role === "admin" ? true : false;
  let isUser = data && data.role === "user" ? true : false;

  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <>
      <div className="navbar">
        <Link to={isAdmin ? "/admin/dashboard" : "/dashboard"} className="logo">
          <img src={Logo} alt="Logo" width="150px" />
        </Link>
        <div className="_nav_right">
          {isAdmin ? (
            <div
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
              onClick={() => setIsOpen(false)}
            >
              <Link to="/admin/dashboard" className={pathname === "/admin/dashboard" ? "nav_link active" : "nav_link"}> Pensioners </Link>
              <Link to="/admin/collection" onClick={toggleDrawer} className={pathname === "/admin/collection" ? "nav_link active" : "nav_link"}>

                Collection
              </Link>
              <Link to="/admin/paygo" onClick={toggleDrawer} className={pathname === "/admin/paygo" ? "nav_link active" : "nav_link"}>

                PayGo
              </Link>
              <Link to="/admin/expense" onClick={toggleDrawer} className={pathname === "/admin/expense" ? "nav_link active" : "nav_link"}>

                Pension Expense
              </Link>
              <Link to="/admin/participants" onClick={toggleDrawer} className={pathname === "/admin/participants" ? "nav_link active" : "nav_link"}>
                Participants

              </Link>

            </div>
          ) : isUser ? (
            <div
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
              onClick={() => setIsOpen(false)}
            >
              <Link to="/dashboard" className={pathname === "/dashboard" ? "nav_link active" : "nav_link"}> Pensioners </Link>
              <Link to="/collection" onClick={toggleDrawer} className={pathname === "/collection" ? "nav_link active" : "nav_link"}>

                Collection
              </Link>
              <Link to="/paygo" onClick={toggleDrawer} className={pathname === "/paygo" ? "nav_link active" : "nav_link"}>

                PayGo
              </Link>
              <Link to="/expense" onClick={toggleDrawer} className={pathname === "/expense" ? "nav_link active" : "nav_link"}>

                Pension Expense
              </Link>
              <Link to="/participants" onClick={toggleDrawer} className={pathname === "/participants" ? "nav_link active" : "nav_link"}>
                Participants

              </Link>
            </div>
          ) : null}
          {data ? (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <p style={{ padding: 0, margin: 0 }}>{data.name}</p>
              <AiOutlinePoweroff size='20' color="#ffc107" style={{ cursor: "pointer" }} onClick={() => Logout()} />
            </div>) : null}
        </div>

        <img
          src={ToggleIcon}
          alt=""
          width="30px"
          onClick={toggleDrawer}
          className="drawer_toggle"
        />
      </div>

      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="right"
        className="bla bla bla"
      >
        <br />
        <br />
        {isAdmin ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Link to="/admin/dashboard" className={pathname === "/admin/dashboard" ? "nav_link active" : "nav_link"}> Pensioners </Link>
            <Link to="/admin/collection" onClick={toggleDrawer} className={pathname === "/admin/collection" ? "nav_link active" : "nav_link"}>

              Collection
            </Link>
            <Link to="/admin/paygo" onClick={toggleDrawer} className={pathname === "/admin/paygo" ? "nav_link active" : "nav_link"}>

              PayGo
            </Link>
            <Link to="/admin/expense" onClick={toggleDrawer} className={pathname === "/admin/expense" ? "nav_link active" : "nav_link"}>

              Pension Expense
            </Link>
            <Link to="/admin/participants" onClick={toggleDrawer} className={pathname === "/admin/participants" ? "nav_link active" : "nav_link"}>
              Participants

            </Link>
          </div>
        ) : isUser ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Link to="/dashboard" className={pathname === "/dashboard" ? "nav_link active" : "nav_link"}> Pensioners </Link>
            <Link to="/collection" onClick={toggleDrawer} className={pathname === "/collection" ? "nav_link active" : "nav_link"}>

              Collection
            </Link>
            <Link to="/paygo" onClick={toggleDrawer} className={pathname === "/paygo" ? "nav_link active" : "nav_link"}>

              PayGo
            </Link>
            <Link to="/expense" onClick={toggleDrawer} className={pathname === "/expense" ? "nav_link active" : "nav_link"}>

              Pension Expense
            </Link>
            <Link to="/participants" onClick={toggleDrawer} className={pathname === "/participants" ? "nav_link active" : "nav_link"}>
              Participants

            </Link>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Link to="/"> Login </Link>
            <Link to="/register"> Register </Link>
          </div>
        )}
        <br />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {data ? (
            <button className="logout_btn" onClick={() => Logout()}>
              Logout
            </button>
          ) : null}
        </div>
      </Drawer>
    </>
  );
};

export default Navbar;
